/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */
/**
 * This file contains all WordPress Integration JavaScript functionality
 */

'use strict';

(function ($) {
	/**
	 * get the selected period's elements.
	 * @param {string} year - year of selected period
	 * @param {string} month - month of selected period
	 * @returns {string} returns month and year
	 */
	function getSelectedPeriodElements(year, month) {
		let yearParam = year;
		let monthParam = month;
		if (yearParam) {
			$('.blog-year-wrapper .blog-year').each(function (i, yearEl) {
				if ($(yearEl).find('a').text() === yearParam) {
					yearParam = yearEl;

					if (monthParam) {
						$(yearEl)
							.nextAll('.blog-month')
							.each(function (j, monthEl) {
								if ($(monthEl).find('a').text() === monthParam) {
									monthParam = monthEl;
								}
							});
					}
				}
			});
		}
		yearParam = year;
		monthParam = month;
		return { year, month };
	}

	$(document).ready(function () {
		$('.blog-content-asset').find('[style]').removeAttr('style');

		const WpiController = {
			cache: {},

			// cache elements which will be selected multiple times
			initializeCache: function () {
				WpiController.cache = {
					blogArticles: $('#blog-articles'),
					blogCategoryId: $('#blog-category-id'),
					blogYear: $('#blog-year'),
					blogMonth: $('#blog-month'),
				};
			},

			// initialize the events
			initializeEvents: function () {
				WpiController.loadArticles();
				WpiController.sortArticles();
				WpiController.toggleMonths();
				WpiController.archiveMenuDate();
				$('body').on('click', '#fa-link', function (event) {
					event.preventDefault();
					const $temp = $('<input>');
					$('body').append($temp);
					$temp.val($('#shareUrl').val()).select();
					document.execCommand('copy');
					$temp.remove();
				});
			},

			articlesRequestConfigs: function () {
				/**
				 * Returns the FDID for the blog category
				 * @param {Object} WpiController - the WpiController object
				 * @returns {number} - the FDID for the blog category
				 */
				function getFdid() {
					let result = 0;
					// add the category id to the ajax request if it is a category page
					if (WpiController.cache.blogCategoryId.length === 1) {
						result = WpiController.cache.blogCategoryId.val();
					}
					return result;
				}

				/**
				 * Returns the year from the WpiController cache
				 * @param {Object} WpiController - the WpiController object
				 * @returns {number} result - the year from the WpiController cache
				 */
				function getYear() {
					let result = null;
					// add the year to the ajax request
					if (WpiController.cache.blogYear.length === 1) {
						result = WpiController.cache.blogYear.val();
					}
					return result;
				}

				/**
				 * Returns the month from the WpiController cache
				 * @param {WpiController} WpiController - the WpiController object
				 * @returns {string} - the month from the WpiController cache
				 */
				function getMonth() {
					let result = null;
					// add the month to the ajax request
					if (WpiController.cache.blogMonth.length === 1) {
						result = WpiController.cache.blogMonth.val();
					}
					return result;
				}

				let fdid = getFdid();
				let blogYear = getYear();
				let blogMonth = getMonth();
				let lastPrintedPeriod = null;
				let isArchive = false;

				// set the call url
				if ($('#blog-archive-title').length === 1) {
					lastPrintedPeriod = $('.blog-subtitle').last().html().trim();
					isArchive = true;
				}

				return {
					fdid: fdid,
					blogYear: blogYear,
					blogMonth: blogMonth,
					lastPrintedPeriod: lastPrintedPeriod,
					isArchive: isArchive,
				};
			},
			// retrieves articles and adds them to the page
			loadArticles: function () {
				WpiController.cache.blogArticles.on(
					'click',
					'#load-more',
					function (e) {
						e.preventDefault();
						$('body').prepend('<div class="spinner" id="spinner"></div>');
						$('#wrapper').css({ opacity: '0.4' });

						const { fdid, blogYear, blogMonth, lastPrintedPeriod, isArchive } =
							WpiController.articlesRequestConfigs();

						const callUrl = $(this).attr('href');
						const excludedArticleID = $(this).data('list');
						const srule = $('#srule').val();
						const startFrom = $('#article-count').data('article-count');
						$.ajax({
							url: callUrl,
							type: 'GET',
							data: {
								start_from: startFrom,
								fdid: fdid,
								blog_year: blogYear,
								blog_month: blogMonth,
								last_printed_period: lastPrintedPeriod,
								srule: srule,
								archive: isArchive,
								excludedArticleID: excludedArticleID,
							},
							success: function (response) {
								$('#load-more').parent().remove();
								$('#article-count').remove();
								WpiController.cache.blogArticles.append(response);
								$('#spinner').remove();
								$('#wrapper').css({ opacity: '1' });
							},
						});
					}
				);
			},

			// handle sort option selection
			sortArticles: function () {
				WpiController.cache.blogArticles.on(
					'change',
					'.js-article-sorting',
					function (e) {
						e.preventDefault();
						$('body').prepend('<div class="spinner" id="spinner"></div>');
						$('#wrapper').css({ opacity: '0.4' });

						const { fdid, blogYear, blogMonth, lastPrintedPeriod, isArchive } =
							WpiController.articlesRequestConfigs();

						const callUrl = $(this).data('link');

						const srule = $(this).val();
						$('#srule').val(srule);
						const sortSelectTag = $(this);

						$.ajax({
							url: callUrl,
							type: 'GET',
							data: {
								start_from: 0,
								count:
									WpiController.cache.blogArticles.find('> article').length,
								fdid: fdid,
								blog_year: blogYear,
								blog_month: blogMonth,
								last_printed_period: lastPrintedPeriod,
								srule: srule,
								archive: isArchive,
							},
							success: function (response) {
								$('#load-more').parent().remove();
								WpiController.cache.blogArticles.html(response);
								WpiController.cache.blogArticles.prepend(sortSelectTag);
								$('#spinner').remove();
								$('#wrapper').css({ opacity: '1' });
							},
						});
					}
				);
			},
			archiveMenuDate: function () {
				const yearInp = $('#blog-month').val();
				const monthInp = $('#blog-year').val();

				const { month, year } = getSelectedPeriodElements(monthInp, yearInp);

				if (month) {
					$(month).addClass('date-cheked');
				} else {
					$(year).addClass('date-cheked');
				}
			},

			toggleMonths: function () {
				$('.js-expand-months').on('click', function (e) {
					e.preventDefault();

					$(this)
						.nextAll('.blog-month')
						.each((i, month) => {
							$(month).toggle();
						});
				});
			},

			init: function () {
				WpiController.initializeCache();
				WpiController.initializeEvents();
			},
		};

		$('.dropdown-menu a.dropdown-toggle').on('click', function () {
			if (!$(this).next().hasClass('show')) {
				$(this)
					.parents('.dropdown-menu')
					.first()
					.find('.show')
					.removeClass('show');
			}
			const $subMenu = $(this).next('.dropdown-menu');
			$subMenu.toggleClass('show');
			return false;
		});

		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (!mutation.target.classList.contains('show')) {
					$(mutation.target).find('.show').removeClass('show');
				}
			});
		});

		if (document.querySelector('#bloglink-menu')) {
			const target = document.querySelector('#bloglink-menu');
			observer.observe(target, {
				attributes: true,
				attributeFilter: ['class'],
			});
		}

		WpiController.init();
	});
})(window.jQuery);
